import { useState, useMemo } from "react"
import { Calendar, Clock, Plus, X, ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "../../ui/button"
import { Checkbox } from "../../ui/checkbox"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select"
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card"
import { Calendar as CalendarComponent } from "../../ui/calendar"
import { Badge } from "../../ui/badge"
import { Row, Col, Input, Tabs } from '../../ui/ot'
import HolidaySetting from './holiday_and_closure_management'
import OpeningHoursManagement from "./opening_hours_management"
const LibraryOpeningHoursManagement = ({

}) => {
    return (<Row>
        <Col span={24}>
            <Tabs
                items={[
                    {
                        tab: "常規開館設定",
                        key: "常規開館設定"
                    },
                    {
                        tab: "假日設定",
                        key: "假日設定"
                    }
                ]}
            >
            </Tabs>
        </Col>
        <Col span={24}>
            <OpeningHoursManagement />
        </Col>
        <Col span={24}>
            <HolidaySetting />
        </Col>
    </Row>)
}
export default LibraryOpeningHoursManagement